import { SIGNED_OUT_PARAM, type SessionEndReason } from "@platform/user/client";

// The router state key that carries why a session ended to the login page.
export const SESSION_END_REASON_STATE = "sessionEndReason";

const SESSION_EXPIRED_MESSAGE =
  "Your session has expired, please sign in again.";

const MESSAGES: Readonly<Record<SessionEndReason, string | undefined>> = {
  user: undefined,
  expired: SESSION_EXPIRED_MESSAGE,
  unauthorized: SESSION_EXPIRED_MESSAGE,
  unsupportedRole:
    "Your account doesn't have access to the portal. Contact support if you think this is a mistake.",
};

const isSessionEndReason = (value: unknown): value is SessionEndReason =>
  typeof value === "string" && Object.hasOwn(MESSAGES, value);

/**
 * The message for a session that just ended, if any. The reason arrives in the router
 * state after a local logout, or in the URL after Auth0 redirects back from an SSO one.
 */
export const sessionEndMessage = (
  routerState: unknown,
  search: string,
): string | undefined => {
  const fromState =
    typeof routerState === "object" &&
    routerState !== null &&
    SESSION_END_REASON_STATE in routerState
      ? routerState[SESSION_END_REASON_STATE]
      : undefined;
  const reason = fromState ?? new URLSearchParams(search).get(SIGNED_OUT_PARAM);

  return isSessionEndReason(reason) ? MESSAGES[reason] : undefined;
};
